import { Text } from '@/components/Text/Text'
export function Italic({
    children,
    ...rest
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) {
    return (
        <Text tag="i" size="inherit" style={{ fontStyle: 'italic' }} {...rest}>
            {children}
        </Text>
    )
}
